class Header {
  constructor( settings ) {
    this.height = window.innerHeight
    this.width = window.innerWidth

    this.init()
    this.hasOpenMenu = false
    this.hasOpenLogout = false
  }

  init () {
    this.cacheDOM()
    this.bindEvents()

    this.$offset = this.$header.offset()
  }

  cacheDOM () {
    this.$header = $( "#main_header" )
    this.$parent = $( ".main-navigation ul li.menu-item-has-children:not('.has-mega')" )
    this.$main_menu = $( ".menu-main-navigation-container" )
    this.$menu_toggle = $( ".menu-toggle" )
    this.$logout_btn = $( ".btn-logout" )
    this.$member_btn = $( ".logged-in-btn" )
  }

  bindEvents () {
    $( "#primary-menu > li.menu-item-has-children > a" ).on( "click", this.preventParentAnchorClick.bind( this ) )
    $( '.main-navigation ul li.menu-item-has-children' ).on( "mouseenter", this.toggleSubMenu.bind( this ) )
    $( '.main-navigation ul li.menu-item-has-children' ).on( "mouseleave", this.toggleSubMenu.bind( this ) )
    $( 'body' ).on( "click", '.main-navigation ul li.menu-item-has-children > a', this.toggleSubMenu.bind( this ) )

    this.$member_btn.on( 'mouseenter', this.toggleLogOutBtn.bind( this ) )
    this.$member_btn.on( 'mouseleave', this.toggleLogOutBtn.bind( this ) )
    this.$logout_btn.on( 'mouseleave', this.toggleLogOutBtn.bind( this ) )

    this.$menu_toggle.on( "click", this.toggleMobileMenu.bind( this ) )
    $( 'body' ).on( "click", ".back-btn", this.backMenu.bind( this ) )

    $( window ).on( 'resize', this.resetMenu.bind( this ) )
  }

  toggleLogOutBtn ( e ) {
    const RELATED_TARGET = $( e.relatedTarget )
    const CURRENT_TARGET = $( e.currentTarget )

    if ( this.isMobile() ) return

    if ( 'mouseenter' === e.type && CURRENT_TARGET.hasClass( 'logged-in-btn' ) ) {
      this.$logout_btn.addClass( "active" )
    } else if ( 'mouseleave' === e.type && !RELATED_TARGET.hasClass( 'btn-logout' ) ) {
      this.$logout_btn.removeClass( "active" )
    }
  }

  setStaticHeader ( e ) {
    if ( $( window ).scrollTop() > this.$offset.top ) {
      this.$header.addClass( "sticky" )
    } else {
      this.$header.removeClass( "sticky" )
    }
  }

  preventParentAnchorClick ( e ) {
    if ( this.isMobile() ) {
      e.preventDefault()

      if ( $( e.currentTarget ).parents( '.has-mega' ).length ) {
        return false
      }

      $( e.currentTarget ).parent().parent().children( 'li' ).addClass( 'hide-mega' )
      $( '.back-btn' ).remove()
      $( '.menu' ).addClass( 'no-pad' )
      $( '.menu-main-navigation-container > .search-form' ).removeClass( 'active' )
      $( e.currentTarget ).parent().removeClass( 'hide-mega' )
      $( e.currentTarget ).parent().addClass( 'has-mega' ).prepend( '<div class="back-btn"></div>' )
    }

    return true
  }

  toggleSubMenu ( e ) {

    if ( 'click' === e.type && this.isMobile() && !this.hasOpenMenu ) {
      this.hasOpenMenu = true
      $( e.currentTarget ).parent().find( ".meaga-menu-container" ).toggleClass( "active" )
      e.preventDefault()
    } else if ( ( 'mouseenter' === e.type || 'mouseleave' === e.type ) && !this.isMobile() ) {
      $( e.currentTarget ).find( ".meaga-menu-container" ).toggleClass( "active" )
    }
  }

  toggleMobileMenu ( e ) {
    e.stopPropagation()
    this.hasOpenMenu = false
    $( '.meaga-menu-container' ).removeClass( 'active' )
    $( '.hide-mega' ).removeClass( 'hide-mega' )
    $( '.has-mega' ).removeClass( 'has-mega' )
    $( '.menu' ).removeClass( 'no-pad' )
    $( '.back-btn' ).remove()
    this.$main_menu.toggleClass( "active" )
    $( e.currentTarget ).toggleClass( 'close' )
    this.$header.toggleClass( 'mobile-active-header' )
  }

  backMenu ( e ) {
    $( '.hide-mega' ).removeClass( 'hide-mega' )
    $( '.has-mega' ).removeClass( 'has-mega' )
    $( '.menu' ).removeClass( 'no-pad' )
    $( '.back-btn' ).remove()
    $( '.meaga-menu-container' ).removeClass( 'active' )
    $( '.menu-main-navigation-container > .search-form' ).addClass( 'active' )
    this.hasOpenMenu = false
  }

  resetMenu ( e ) {

    if ( window.innerWidth == this.width ) {
      return false
    }

    $( '.menu-main-navigation-container' ).removeClass( 'active' )
    $( '.mobile-active-header' ).removeClass( 'mobile-active-header' )
    $( '.hide-mega' ).removeClass( 'hide-mega' )
    $( '.has-mega' ).removeClass( 'has-mega' )
    $( '.menu' ).removeClass( 'no-pad' )
    $( '.back-btn' ).remove()
    $( '.meaga-menu-container' ).removeClass( 'active' )
    $( '.menu-main-navigation-container > .search-form' ).addClass( 'active' )
    this.$menu_toggle.removeClass( 'close' )
    this.hasOpenMenu = false
  }

  isMobile () {
    if ( window.innerWidth <= 1200 ) {
      return true
    } else {
      return false
    }
  }
}

new Header()
